import { FontFaceMapType, FontFaceType } from "./interfaces";
import { Full, KeysOfType } from '@/common/types';

class FontManagerSingleton {
	loadedFontFaces: Array<FontFaceType> = [];

	findLoadedFace(fontFace: FontFaceType): FontFaceType | null {
		for (const loadedFace of this.loadedFontFaces) {
			if (
				loadedFace.filePath === fontFace.filePath
				&& loadedFace.variable === fontFace.variable
				&& (
						(
							!Array.isArray(loadedFace.weight)
							&& loadedFace.weight === fontFace.weight
						)
						||
						(
							Array.isArray(loadedFace.weight) && Array.isArray(fontFace.weight)
							&& loadedFace.weight[0] === fontFace.weight[0] && loadedFace.weight[1] === fontFace.weight[1]
						)
				)
			) {
				return loadedFace;
			}
		}

		return null;
	}

	async loadFontFamily(cssName: string, fontFamily: FontFaceMapType): Promise<void> {
		type FontFaceTypeKeys = KeysOfType<Full<FontFaceMapType>, FontFaceType>;

		for (const fontFaceKey of ['regular', 'italic', 'bold', 'boldItalic'] as Array<FontFaceTypeKeys>) {
			const fontFace = fontFamily[fontFaceKey];

			if (fontFace === undefined) {
				continue;
			}

			const existing = this.findLoadedFace(fontFace);

			if (existing !== null) {
				return Promise.resolve();
			}

			const opts: FontFaceDescriptors = {};

			if (fontFace.weight) {
				opts.weight = Array.isArray(fontFace.weight)? fontFace.weight.join('-') : fontFace.weight.toString();
			} else {
				opts.weight = '100 900';
			}

			if (fontFaceKey.toLocaleLowerCase().includes('italic')) {
				opts.style = 'italic';
			}

			const loadedFont = new FontFace(
				cssName,
				`url(/static/fonts/${fontFace.filePath})`,
				opts
			);

			document.fonts.add(loadedFont);

			await loadedFont.load();

			this.loadedFontFaces.push(fontFace);
		}

		return Promise.resolve();
	}
}

export const FontManager = new FontManagerSingleton();
